<template>
  <div>
    <!-- 第一部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">迷你洁齿骨</span>
              <span class="title_en_box"> 建议0.5-4.5kg狗狗食用 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/smartbone_classic01.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 20px; color: #2963a4">
              要愉悦，更要健康！<br />
              不含生皮配方，保护狗狗脆弱肠道<br
            /></strong>
            用有益健康的新鲜蔬菜和纯正鸡肉做成，含多种维生素和矿物质，给狗狗制定最完美的饮食配方。<br />

            别再盲目的喂胖爱宠啦！低脂肪配方，注重狗狗身体健康。<br />

            营养全面丰富，加上超强的柔软度，专为迷你狗狗定制迷你型洁齿骨，狗狗食用起来，美味不急躁！<br />

            <strong>迷你洁齿骨有5种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic02.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨牛肉味(迷你)</span>
              <span class="title_en">Beef flavour </span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic03.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨鸡肉味(迷你)</span>
              <span class="title_en">Chicken flavour </span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic04.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <div class="title_contain">
              <span class="title_intro">洁齿骨鸡肉味(迷你)</span>
              <span class="title_en">Chicken flavour </span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic05.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">小号洁齿骨</span>
              <span class="title_en_box"> 建议4.5-11.5kg狗狗食用 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/smartbone_classic06.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 20px; color: #2963a4">
              高颜值与美味并存，<br />
              让狗狗无法拒绝的洁齿骨！</strong
            ><br />
            SmartBones的外层是由健康的蔬菜制成，包括玉米、红薯、豌豆和胡萝卜。增加狗狗食欲，让狗狗无法拒绝！
            <br />

            SmartBones将会是狗狗最好的玩伴！而且不含碎渣，洁齿更柔软，专为小型狗狗定制迷你型洁齿骨，保护狗狗牙龈，保持口腔健康！
            <br />

            <strong>小号洁齿骨有4种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic07.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨牛肉味&鸡肉味(小号)</span>
              <span class="title_en">Beef flavour && Chicken flavour</span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic08.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨健齿味&花生味(小号)</span>
              <span class="title_en">Toothfriendly && Peanut flavour</span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic09.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <p style="margin-top: 30px">
          <span style="font-size: 20px; color: #2963a4; line-height: 1.75em">
            健齿味内含小苏打和叶绿素，可有效减少牙结石，清新口气，长期使用，可帮助牙齿健康
          </span>
        </p>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">中号洁齿骨</span>
              <span class="title_en_box"> 建议11.5-22.5kg狗狗食用 </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/smartbone_classic10.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 20px; color: #2963a4">
              洁牙健齿，专注狗狗口腔护理<br />
              不含牛皮，爱吃好消化</strong
            ><br />
            外裹蔬菜洁牙健齿层，内夹美味真鸡肉。
            <br />

            动物营养专家推荐使用。长期食用，可去除口臭，有效去除食物残渣、牙菌斑，预防牙结石、牙龈炎等。
            <br />
            富含维生素和矿物质，专为中型狗狗定制迷你型洁齿骨，可以有效清洁牙齿以及保护牙齿健康。
            <br />

            <strong>中号洁齿骨有5种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic11.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro"
                >洁齿骨牛肉&鸡肉&健齿&花生&地瓜味(中号)</span
              >
              <span class="title_en">Multiple flavours</span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic12.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
      </div>
    </div>

    <!-- 第四部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain_box">
              <span class="title_intro_box">大号洁齿骨</span>
              <span class="title_en_box"> 建议22.5kg以上狗狗食用</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex a-center" style="flex-direction: column">
        <div style="width: 1000px">
          <img
            src="../assets/smartbone_classic13.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <div style="width: 900px; text-align: left; margin-top: 40px">
          <p style="font-size: 20px; color: #333; line-height: 2em">
            <strong style="font-size: 20px; color: #2963a4">
              均衡营养，低脂健康，<br />
              洁齿陪伴无烦恼
              <br
            /></strong>
            外裹蔬菜洁牙健齿层，内夹美味真鸡肉。
            <br />

            打好牙龈健康基础，强壮狗狗牙齿。柔韧度和柔软度适中，不伤害狗狗牙龈健康。
            <br />

            动物营养专家推荐使用，专为大型狗狗定制迷你型洁齿骨，有效去除食物残渣、牙菌斑，预防牙结石、牙龈炎等！
            <br />
            <strong>大号洁齿骨有5种口味可供选择：</strong>
          </p>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic14.jpg"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨牛肉味&鸡肉味(大号)</span>
              <span class="title_en">Beef && Chicken flavours</span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic15.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>

        <!-- 标题 -->
        <div class="title" style="margin-top: 60px">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">洁齿骨健齿&花生&地瓜味(大号)</span>
              <span class="title_en">Multiple flavours</span>
            </div>
          </div>
        </div>
        <div style="width: 1000px; margin-top: 30px">
          <img
            src="../assets/smartbone_classic16.png"
            alt=""
            style="width: 100%; vertical-align: middle"
          />
        </div>
        <p style="margin-top: 30px">
          <span style="font-size: 20px; color: #2963a4; line-height: 1.75em">
            健齿味内含小苏打和叶绿素，可有效减少牙结石，清新口气，长期使用，可帮助牙齿健康
          </span>
        </p>
      </div>
    </div>

    <!-- 底部栏 -->
    <foot></foot>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}
.j-sb {
  justify-content: space-between;
}
.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .title_contain_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 200px;
    background-color: #2963a4;
    .title_intro_box {
      font-size: 46px;
      color: #fff;
      font-weight: 600;
      text-align: center;
    }
    .title_en_box {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #fff;
    }
  }
}

.second_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.titleBox {
  padding: 4px 0;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}
</style>